// inv/src/pages/Home.jsx
import { useTranslation } from 'react-i18next';
import { useInitialData } from '../components/data/DataContext';
import SeoHead from '../seo/seoHead';
import MainBlockFindInvestors from '../blocks/Homepage/CRMSection';
import MainHeader from '../blocks/Homepage/MainHeader';
import TwoColumnSection1 from '../blocks/Homepage/TwoColumnSection1';
import OurDataMarket from '../blocks/Homepage/OurDataMarket';
import DealDetailsSection from '../blocks/Homepage/LastDealsSection';
import HeadingSection1 from '../blocks/Homepage/HeadingSection1';
import Testimonials from '../blocks/Homepage/Testimonials';
import VideoHero from '../blocks/Homepage/VideoHero';
import PurchaseMembershipBlock from '../pages/payment/PurchaseMembershipBlock';

const Home = () => {
  const { t } = useTranslation();
  const { seo = {} } = useInitialData();

  const {
    title,
    description,
    canonicalUrl,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    ogType,
    twitterCard,
    alternates,
    jsonLd,
    lang,
  } = seo;

  return (
    <>
      <SeoHead
        lang={lang || 'en'}
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogImage={ogImage}
        ogUrl={ogUrl}
        ogType={ogType}
        twitterCard={twitterCard}
        alternates={alternates}
        jsonLd={jsonLd}
      />
      <div className="mt-8">
        <MainHeader />
        <VideoHero videoSrc="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/homepage/crino-ai-funding.webm" />
        <OurDataMarket bgColor="relative left-1/2 transform -translate-x-1/2 w-screen flex flex-col lg:flex-row bg-gradient-to-r from-neutral-100 to-orange-50"/>
        <DealDetailsSection bgColor="relative left-1/2 transform -translate-x-1/2 w-screen flex flex-col lg:flex-row"/>
        <TwoColumnSection1 bgColor="relative left-1/2 transform -translate-x-1/2 w-screen flex flex-col lg:flex-row"/>
        <Testimonials bgColor="relative left-1/2 transform -translate-x-1/2 w-screen flex flex-col lg:flex-row"/>
        <div><h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center">Pricing</h2></div>
        <PurchaseMembershipBlock className="px-12 py-8 sm:px-42"/>
        <MainBlockFindInvestors />
        <HeadingSection1 bgColor="relative left-1/2 transform -translate-x-1/2 w-screen flex flex-col lg:flex-row bg-gradient-to-r from-neutral-100 to-orange-50"/>
      </div>
    </>
  );
};

export default Home;
